const BrowserCookies: Cookies.CookiesStatic = require('js-cookie');

export function getCookie(key: string) {
    return BrowserCookies.get(key);
}

export function updateCookie(key: string, value?: string, options?: Cookies.CookieAttributes) {
    if (value) {
        BrowserCookies.set(key, value, options);
    } else {
        BrowserCookies.remove(key);
    }
}
